import apiClient from '@/lib/api/apiClient';
import type { CategoryListResponse } from '../type';

const categoryClient = {
  getList: async (): Promise<CategoryListResponse> => {
    const { data } = await apiClient.get<CategoryListResponse>('/api/v1/categories');
    return data;
  },
};

export default categoryClient;
